import { h, Component } from 'preact';
import { ThemeHoC, BusHoC } from '@/components/hoc';
import { EVENT_QUOTES } from '@/utils/event-bus.js';
import InstrumentItem from './item';

class InstrumentList extends Component {
    constructor (props) {
        super(props);
        this.state = {
            instruments: props.instruments
        };
    }

    updateInstrument (quote) {
        let { instruments } = this.state;
        let updated = 0;
        instruments = instruments.map((instrument) => {
            if (quote.s === instrument.symbol && Number(instrument.value) !== Number(quote.r)) {
                instrument.value = quote.r;
                instrument.percentChange = (((instrument.value * 100) / instrument.close) - 100).toFixed(2);
                updated++;
            }

            return instrument;
        });

        if (updated > 0) {
            this.setState({ instruments });
        }
    }

    componentDidMount () {
        this.props.bus.take(EVENT_QUOTES, (q) => {
            this.updateInstrument(q);
        });
    }

    render ({ theme }, { instruments = [] }) {
        return (
            <div className={theme.table} data-widget="list">
                { instruments.map((instrument, index) => (
                    <InstrumentItem instrument={ {...instrument} } className={index % 2 === 0 ? theme.odd : null} />
                )) }
            </div>
        );
    }
}

export default BusHoC(
    ThemeHoC(
        InstrumentList
    )
);



// WEBPACK FOOTER //
// ./src/components/list/index.js